<div class="navbar landing-section">
  <div class="hrefs">
    <div class="logo">
      <img 
        (click)="goTo('')"
        height="45px"
        src="assets/landing/images/logo.png"
        alt="logo" />
    </div>
    <div class="benefits">
    </div>
  </div>
  <div>
    <div class="buttons-int desktop">
      <button (click)="goTo('home/contact')" class="landing-button primary filled" [style]="'margin-right: 10px'">Contactar a ventas</button>
      <button  (click)="goTo('auth/login')" class="landing-button primary outlined">Iniciar sesión</button>
      <div class="int"></div>
    </div>
    <div class="buttons-int mobile">
      <button (click)="toggleOpenMobileMenu(true)" class="landing-button primary filled">
        <img src="assets/icons/svg/profile-2.svg" alt="log in" height="25px"/>
      </button>
      <app-popover (onClose)="toggleOpenMobileMenu(false)" [open]="openMobileMenu"></app-popover>
    </div>
  </div>
</div>
